var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonalTv = function SvgPersonalTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "personal_tv_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#personal_tv_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.3 13.8 3.225-2.1a.76.76 0 0 0 .288-.3.9.9 0 0 0 .087-.4q0-.225-.087-.4a.77.77 0 0 0-.288-.3L11.3 8.2q-.426-.274-.874-.012-.452.263-.452.762v4.126q0 .498.452.75.448.25.874-.026M9.775 20a.82.82 0 0 1-.6-.25.82.82 0 0 1-.25-.6V18h-4.2Q4 18 3.5 17.5a1.66 1.66 0 0 1-.5-1.225V5.725q0-.724.5-1.225Q4 4 4.726 4h14.548Q20 4 20.5 4.5t.5 1.226v10.549q0 .726-.5 1.225t-1.226.5h-4.2v1.15a.82.82 0 0 1-.25.6.82.82 0 0 1-.6.25zm-5.05-3.1h14.55a.61.61 0 0 0 .45-.174.61.61 0 0 0 .175-.451V5.725a.6.6 0 0 0-.174-.45.6.6 0 0 0-.452-.175H4.726a.6.6 0 0 0-.452.176.6.6 0 0 0-.174.45v10.549q0 .276.174.451a.61.61 0 0 0 .452.174"
  }))));
};
export default SvgPersonalTv;